import { NETWORK } from '@/utils/constants'
export const CREATE_WALLET_STEPS = [
	{
		title: 'Welcome to Ordinals Wallet',
		description:
			`Ordinals wallet is a non-custodial ${NETWORK} wallet that allows users to view and store ${NETWORK} and Ordinals NFTs.`,
		primaryButton: 'Create new wallet',
		secondaryButton: 'Restore wallet'
	},
	{
		title: 'Create a password',
		description: 'You will use this to unlock your wallet.',
		disclaimer: 'Your new seed phrase will show on the screen',
		primaryButton: 'Generate seed phrase',
		secondaryButton: null
	},
	{
		title: 'Secret recovery phrase',
		description:
			'This is the only way you will be able to recover your account. Never share it with anyone.',
		primaryButton: 'Next',
		secondaryButton: null
	},
	{
		title: 'Confirm back up',
		description: 'Select words 3, 6, 9 and 12 of your secret recovery phrase.',
		primaryButton: 'Next',
		secondaryButton: 'Go back'
	},
	{
		title: 'Success!',
		description: `Your ordinals ${NETWORK} wallet is alive!`,
		primaryButton: 'Enter',
		secondaryButton: ''
	}
]

export const RESTORE_WALLET_STEPS = [
	{
		title: 'placeholder',
		description: 'placeholder',
		primaryButton: 'placeholder',
		secondaryButton: 'placeholder',
		disclaimer: null
	},
	{
		title: 'Restore wallet',
		description: 'Only input a seed you generated from ordinalswallet.com. Sparrow and others not yet supported.',
		primaryButton: 'Restore wallet'
	},
	{
		title: 'Create a password',
		description: 'You will use this to unlock your wallet.',
		primaryButton: 'Enter',
		secondaryButton: null
	}
]

export const URL_WARNING = `Double check the URL you are on is ordinalswallet.com. Inputting your seed into any other website is extremely dangerous and could result in loss of your Bitcoins and Ordinals.`
